import { useQuery } from '@tanstack/react-query';
import {
  ConditionEntityType,
  ConditionGroup,
  ConditionProductType,
  ConditionTemplate,
  ConditionValue,
} from '../../@types/api';
import { QUERY_KEYS } from '../../constants';
import { getData } from '../../utils/api';

type UseGetConditionsByIdParams = {
  conditionModelType?: ConditionEntityType;
  modelId?: string | null;
  product?: ConditionProductType;
};

export const useGetConditionsById = ({ conditionModelType, modelId, product }: UseGetConditionsByIdParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.conditions, conditionModelType, modelId, product],

    queryFn: (): Promise<{ items: ConditionValue[] }> =>
      getData(`conditions/${conditionModelType}/${modelId}`, {
        product,
      }),

    select: (data) => data.items,
    enabled: !!conditionModelType && !!modelId,
  });

type UseGetConditionGroupsParams = {
  conditionModelType?: ConditionEntityType;
};

export const useGetConditionGroups = ({ conditionModelType }: UseGetConditionGroupsParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.conditionGroups, { type: conditionModelType }],

    queryFn: (): Promise<{ items: ConditionGroup[] }> =>
      getData('condition-groups', {
        type: conditionModelType,
        limit: 100,
      }),

    select: (data) => data?.items,
    enabled: !!conditionModelType,
  });

type UseGetConditionTemplatesParams = {
  conditionGroupId?: string | null;
  options?: {
    enabled?: boolean;
  };
};

export const useGetConditionTemplates = ({ conditionGroupId, options }: UseGetConditionTemplatesParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.conditionTemplates, { conditionGroupId }],

    queryFn: (): Promise<{ items: ConditionTemplate }> =>
      getData('condition-templates', {
        conditionGroupId,
      }),

    select: (data) => data?.items,
    ...options,
  });
